import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import styles from './styles';

const BlockScreenRaw = ({ openBlockScreen, className, BackdropProps }) => openBlockScreen && (
  <Backdrop
    invisible={!openBlockScreen}
    className={className}
    open={openBlockScreen}
    {...BackdropProps}
  >
    <CircularProgress color="inherit" />
    <Box className="dn-text">
      <Typography>
        <span className="dot-collision" />
      </Typography>
    </Box>
  </Backdrop>
);

BlockScreenRaw.propTypes = {
  openBlockScreen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  BackdropProps: PropTypes.object,
};

const BlockScreen = styled(BlockScreenRaw)`${styles}`;

BlockScreen.propTypes = BlockScreenRaw.propTypes;

export default BlockScreen;
